import { APP_PERMISSIONS } from '@exam-center/permission';
import { Navigate, useParams } from '@exam-center/router';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

export default function ExamLocationManagementPage() {
  const { examCenterCode } = useParams('/:examCenterCode/exam-location');
  const { permissions } = usePermission();

  const initialTab = useMemo(() => {
    if (permissions.includes(APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW)) {
      return 'locations';
    }
    if (permissions.includes(APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW)) {
      return 'requests';
    }
    return 'cancellations';
  }, [permissions]);

  return (
    <Navigate
      to={`/:examCenterCode/exam-location/${initialTab}`}
      replace
      params={{ examCenterCode }}
    />
  );
}
